import { createSelector } from '@reduxjs/toolkit';

import { RootState, useAppSelector } from '..';

export const selectUser = (state: RootState) => state.user;
export const useUser = () => useAppSelector(selectUser);

export const selectCurrentAccount = createSelector(
  [selectUser, (state: RootState) => state.selectedAccount.activeAccountId],
  (user, activeAccountId) => ({
    userAccount: user?.data?.accounts.find(acc => acc.account.id === activeAccountId),
    ...user,
  }),
);
export const useCurrentAccount = () => useAppSelector(selectCurrentAccount);
